import React, { useRef } from "react";
import ReactSelect from "react-select";

import { selectStyle, selectTheme } from "./settings";
import { useNormalizer, WpTermToSelectOption } from "../utils";

/**
 * Configuration
 */
import config from "../config";
const { texts, blockClassName } = config;

const Tags = ({ label, placeholder, options, selected, setSelected }) => {
	const normalizedOptions = useNormalizer(options, WpTermToSelectOption);

	if (!normalizedOptions || !normalizedOptions.length) return null;

	return (
		<div className="tags">
			<div className="tags__label input-label">{label}</div>

			<button
				className={`tags__tag ${selected?.length === 0 ? "is-active" : ""}`}
				onClick={() => setSelected([])}
			>
				{texts?.show_all}
			</button>

			{normalizedOptions.map((tag, key) => (
				<button
					className={`${
						selected.includes(tag.value) ? "is-active " : ""
					}tags__tag`}
					onClick={() => setSelected([tag.value])}
					key={key}
				>
					{tag.label}
				</button>
			))}
		</div>
	);
};

export default Tags;
